import React, {Component} from 'react';
import {Mutation} from 'react-apollo';
import css from './groupsList.scss';
import Popup from '../popup/popup';
import {GET_GROUPS, DELETE_GROUP} from './queries';
import {GET_USERS} from '../usersTable/queries';

class DeleteGroup extends Component {
	updateCache = cache => {
		const groupsData = cache.readQuery({query: GET_GROUPS});
		groupsData.groups = groupsData.groups.filter(
			({id}) => id !== this.props.groupId,
		);
		cache.writeQuery({query: GET_GROUPS, data: groupsData});

		const usersData = cache.readQuery({query: GET_USERS});
		usersData.users = usersData.users.map(user => {
			if (user.group && user.group.id === this.props.groupId) {
				user.group = null;
			}
			return user;
		});
		cache.writeQuery({query: GET_USERS, data: usersData});
	};
	render() {
		return (
			<Mutation
				mutation={DELETE_GROUP}
				variables={{id: this.props.groupId}}
				update={this.updateCache}
			>
				{(deleteGroup, {error}) => {
					return [
						<button
							key="btn"
							className={css.delete}
							onClick={_ => this.popup.open()}
						/>,
						<Popup
							key="popup"
							ref={n => (this.popup = n)}
							onConfirm={_ => deleteGroup()}
						>
							Attention&nbsp;! Vous êtes sur le point de supprimer
							un groupe. Êtes-vous sûr&nbsp;?
						</Popup>,
					];
				}}
			</Mutation>
		);
	}
}

export default DeleteGroup;



// WEBPACK FOOTER //
// ./src/groupsList/deleteGroup.js